import { JobList } from "../../../../assets/data/Constants";
import {
  ITkCsvValidateObject,
  TkCsvValidateProps,
} from "../../../../type/componentsType/TkCsvUpload";
import { TypeTableBody } from "../../../../type/componentsType/TkTable";
import TkPropertyMessageGet from "../../../../utils/TkPropertyMessageGet";
import {
  MaxErrorNum,
  headList,
  headListBank,
  houjinStaffInfoValidate,
  houjinStaffMonthlySalaryValidate,
} from "../parts";
import { nonDeliverData } from "./useNonDeliveryDetail";
import { transferResultData } from "./useTransferResult";

// フォーマットデータに変換
const getFormatData = (csvValue: any[], type: any) => {
  let csvResult: object[] = [];

  const validations: ITkCsvValidateObject = {
    houjinStaffInfo: houjinStaffInfoValidate,
    houjinStaffMonthlySalary: houjinStaffMonthlySalaryValidate,
  };

  const validate = validations[type];

  csvValue.forEach((item, index) => {
    let res: { [key: string]: string } = {};

    validate &&
      validate.forEach((csvItem, temIndex) => {
        const value = item[temIndex];
        res = {
          ...res,
          [csvItem.name]: value,
        };
        index++;
      });

    csvResult.push(res);
  });
  return csvResult;
};

const validateRequired = (value: any, must: boolean) => {
  if (must && !value) {
    return "TKMSG_SCR0043E";
  }
  return "";
};

const validateLength = (value: any, min: number | null, max: number | null) => {
  if (min && min === max && value.length !== min) {
    return "TKMSG_SCR0077E";
  } else if (max && value.length > max) {
    return "TKMSG_SCR0046E";
  }
  return "";
};

const validateFormat = (
  value: any,
  format: string,
  canBeFullWidth: boolean,
  canBeHalfWidth: boolean
) => {
  switch (format) {
    case "date":
      const dateReg = /^[0-9]{8}$/;
      return !dateReg.test(value) ? "TKMSG_SCR0049E" : "";
    case "number":
      if (!canBeFullWidth) {
        const numberReg = /^[0-9]*$/;
        return !numberReg.test(value) ? "TKMSG_SCR0053E" : "";
      }
      break;
    case "text":
      if (!canBeFullWidth) {
        const halfWidthReg = /^[ｧ-ﾝﾞﾟ\- ]*$/;
        return !halfWidthReg.test(value) ? "TKMSG_SCR0054E" : "";
      } else if (!canBeHalfWidth) {
        const fullWidthReg = /^[^ -~｡-ﾟ]+$/;
        return !fullWidthReg.test(value) ? "TKMSG_SCR0061E" : "";
      }
      break;
  }
  return "";
};

const validateOtherRule = (value: any, otherRule?: RegExp) => {
  return otherRule && !otherRule.test(value) ? "TKMSG_SCR0079E" : "";
};

const formatErrorMessage = (
  errorMsgId: string,
  validateItem: TkCsvValidateProps
) => {
  const nowYear = new Date().getFullYear();
  if (errorMsgId === "TKMSG_SCR0077E" && validateItem.min) {
    return TkPropertyMessageGet(errorMsgId, validateItem.min.toString());
  } else if (errorMsgId === "TKMSG_SCR0046E" && validateItem.max) {
    return TkPropertyMessageGet(errorMsgId, validateItem.max.toString());
  } else if (errorMsgId === "TKMSG_SCR0050E") {
    return TkPropertyMessageGet(errorMsgId, (nowYear - 1).toString());
  } else if (errorMsgId === "TKMSG_SCR0051E") {
    return TkPropertyMessageGet(errorMsgId, nowYear.toString());
  } else {
    return TkPropertyMessageGet(errorMsgId);
  }
};

const validateYear = (value: any) => {
  const nowYear = new Date().getFullYear();
  if (value < nowYear - 1) {
    return "TKMSG_SCR0050E";
  } else if (value > nowYear) {
    return "TKMSG_SCR0051E";
  }
  return "";
};

const handleValidate = (value: any, validateItem: TkCsvValidateProps) => {
  if (!validateItem.must && !value) {
    return "";
  }

  const commonValidations = [
    () => validateRequired(value, validateItem.must),
    () => validateLength(value, validateItem.min, validateItem.max),
    () =>
      validateFormat(
        value,
        validateItem.format,
        validateItem.canBeFullWidth,
        validateItem.canBeHalfWidth
      ),
  ];

  const customValidations = [];

  if (validateItem.name === "jobType") {
    customValidations.push(() =>
      !Object.values(JobList).includes(value) ? "TKMSG_SCR0079E" : ""
    );
  } else if (validateItem.name === "year") {
    customValidations.push(() => validateYear(value));
  } else if (validateItem.otherRule) {
    customValidations.push(() =>
      validateOtherRule(value, validateItem.otherRule)
    );
  }

  const validations = [...commonValidations, ...customValidations];

  for (const validate of validations) {
    const errorMsgId = validate();
    if (errorMsgId) return errorMsgId;
  }

  return "";
};

const handleErrors = (csvValue: any, validateRules: TkCsvValidateProps[]) => {
  let errorList: TypeTableBody[][] = [];
  let count = 0;
  const csvValueData = csvValue.slice(1);

  try {
    csvValueData.forEach((item: any, index: number) => {
      if (Object.keys(item).length !== validateRules.length) {
        errorList.push(
          createErrorEntry(
            count,
            index,
            "項目数",
            "TKMSG_SCR0082E",
            TkPropertyMessageGet("TKMSG_SCR0082E")
          )
        );
        count++;
        if (count >= MaxErrorNum) {
          throw new Error(index.toString());
        }
      } else {
        validateRules.forEach((validateItem) => {
          const value = item[validateItem.index];
          const errorMsgId = handleValidate(value, validateItem);
          if (errorMsgId) {
            let errorMsg = formatErrorMessage(errorMsgId, validateItem);
            errorList.push(
              createErrorEntry(
                count,
                index,
                validateItem.fieldName,
                errorMsgId,
                errorMsg
              )
            );
            count++;
            if (count >= MaxErrorNum) {
              throw new Error(index.toString());
            }
          }
        });
      }
    });
  } catch (e) {
    return { errorList, headList };
  }
  return { errorList, headList };
};

const createErrorEntry = (
  count: number,
  index: number,
  fieldName: string,
  errorMsgId: string,
  errorMsg: string
) =>
  [
    { children: count + 1, align: "center", width: 50 },
    { children: index + 1, align: "center", width: 50 },
    { children: fieldName, width: 200 },
    { children: errorMsgId, width: 200 },
    { children: errorMsg },
  ] as TypeTableBody[];

// テキストを分割
const splitTxtValue = (txtValue: any) => {
  const header = txtValue[0];
  const data = txtValue.slice(1, txtValue.length - 2);
  const trailer = txtValue.length > 2 ? txtValue[txtValue.length - 2] : [""];
  const end = txtValue.length > 3 ? txtValue[txtValue.length - 1] : [""];
  return { header, data, trailer, end };
};

const createErrorEntryNoFieldName = (
  no: number,
  line: number,
  errorMsgId: string,
  errorMsg: string
) =>
  [
    { children: no, align: "center", width: 50 },
    { children: line, align: "center", width: 50 },
    { children: errorMsgId, width: 200 },
    { children: errorMsg },
  ] as TypeTableBody[];

const checkErrorBankResult = (txtValue: any, type: string) => {
  let errorList: TypeTableBody[][] = [];
  let line = 1;
  let count = 0;
  const { header, data, trailer } = splitTxtValue(txtValue);
  const headerLength = type === "transferResult" ? 200 : 120;
  const dataLength = type === "transferResult" ? 200 : 120;
  const trailerLength = type === "transferResult" ? 200 : 120;
  const halfWidth =
    /^([ｱ-ﾝｦA-Z0-9\\(\\)\\.\\-\\/ ]|([-])|([ｳｶ-ﾄﾊ-ﾎ]ﾞ)|([ﾊ-ﾎ]ﾟ))+$/;

  try {
    if (header[0].length !== headerLength) {
      errorList[0] = createErrorEntryNoFieldName(
        count + 1,
        1,
        "TKMSG_SCR0080E",
        TkPropertyMessageGet("TKMSG_SCR0080E")
      );
      count++;
      throw new Error();
    }

    data.forEach((record: any) => {
      let err: any = [];
      line++;
      if (record[0].length !== dataLength) {
        count++;
        err = createErrorEntryNoFieldName(
          count,
          line,
          "TKMSG_SCR0080E",
          TkPropertyMessageGet("TKMSG_SCR0080E")
        );
        errorList.push(err);
      }

      let formatData =
        type === "transferResult"
          ? transferResultData(record)
          : nonDeliverData(record);
      let checkItems =
        type === "transferResult"
          ? [
              "destinationBankName",
              "destinationBranchName",
              "transferRequesterName",
            ]
          : ["bankName", "branchName", "recipientName"];
      let checkResult = checkItems.some((i) => !halfWidth.test(formatData[i]));
      if (checkResult) {
        count++;
        err = createErrorEntryNoFieldName(
          count,
          line,
          "TKMSG_SCR0054E",
          TkPropertyMessageGet("TKMSG_SCR0054E")
        );
        errorList.push(err);
      }
    });
    if (errorList.length > 0) {
      return { errorList, headListBank };
    }

    if (trailer[0]?.length !== trailerLength) {
      count++;
      errorList[0] = createErrorEntryNoFieldName(
        count,
        line + 1,
        "TKMSG_SCR0080E",
        TkPropertyMessageGet("TKMSG_SCR0080E")
      );

      return { errorList, headListBank };
    }
  } catch (e) {
    return { errorList, headListBank };
  }

  return { errorList, headListBank };
};

export {
  getFormatData,
  validateRequired,
  validateLength,
  validateOtherRule,
  validateFormat,
  formatErrorMessage,
  handleErrors,
  createErrorEntry,
  splitTxtValue,
  createErrorEntryNoFieldName,
  checkErrorBankResult,
};
